<script setup lang="ts">
import { useVariablesForMentions } from '@/composables/queries/variables/useVariablesForMentions'

defineOptions({ inheritAttrs: false })

const { t } = useI18n()
const { variables, tooltipLabels, missingBadgeTooltip, invalidBadgeTooltip } =
  useVariablesForMentions()

const modelValue = defineModel<string | undefined>({ required: true })
</script>

<template>
  <OInputMentionsBadge
    v-bind="$attrs"
    v-model="modelValue"
    :options="variables"
    :dropdown-title="t('variables.dropdown_title')"
    :tooltip-labels="tooltipLabels"
    :missing-badge-tooltip="missingBadgeTooltip"
    :error-badge-tooltip="invalidBadgeTooltip"
  />
</template>
